import * as React from "react";
import { Box, Container, Grid } from '@mui/material';
import MUIDataTable from 'mui-datatables';
import Typography from '@mui/material/Typography';
import { MuiThemeProvider } from '@material-ui/core/styles';
import { muiThemeDesign } from '../../mui-theme-design';
import TextField from "@mui/material/TextField";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import OutlinedInput from '@mui/material/OutlinedInput';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import Button from "@mui/material/Button";
import CloseIcon from '@mui/icons-material/Close';
import PieChartIcon from '@mui/icons-material/PieChart';
import moment from "moment";
import CustomSelect from "../CustomComponents/CustomSelect";
import { dateTransformation } from '../../utils.js'
import { Link } from 'react-router-dom';
import {logger, customBodyForExcelReport,handleExport} from '../../utils';
const ExcelJS = require('exceljs');
import { makeStyles } from "@mui/styles";
import ReportGmailerrorredIcon from '@mui/icons-material/ReportGmailerrorred';

export default function POBreakdown({ data }) {
    const [refresh, setRefresh] = React.useState(false);
    const [open, setOpen] = React.useState(false);
    const [ValueAlert, setAlert] = React.useState(false);
    const [alertText, setAlertText] = React.useState('');
    const [succeed, setSucceed] = React.useState(false);
    const [list, setList] = React.useState([])
    const [overTime, setsOverTime] = React.useState([])
    const [Discount, setDiscount] = React.useState({})
    const startDate = moment.utc(data.StartDate).format("YYYY-MM-DD");
	const endDate = moment.utc(data.EndDate).format("YYYY-MM-DD");
    const handleAlertClose = () => {
        setAlert(false);
    };

    const handleClickOpen = () => {
        logger(data)
        logger(overTime)
        setRefresh(true)
        setOpen(true);
    };
    const onTrigger = React.useCallback(() => {
    })

    const handleClose = () => {
        setOpen(false);
    };

    const applyDiscount = (price) => {
        var getPrice = Discount.Discount / 100;

        var totalValue = price - (price * getPrice)
        logger(totalValue.toFixed(2));
        return totalValue.toFixed(2);
    }

	   const calculateRate = (rate, flagType) => {
	    if (overTime.length) {
	        if (flagType === 'OT') {
	            return (rate * overTime[0].OverTimeWeek).toFixed(2);
	        } else if (flagType === 'WND') {
	            return (rate * overTime[0].OverTimeWeekEnd).toFixed(2);
	        } else if (flagType === 'HOL') {
	            return (rate * overTime[0].OverTimeHoliday).toFixed(2);
	        } else {
	            return rate;
	        }
	    }
	};
    
    const pageStyles = makeStyles(theme => ({
    root: {
        "& .MuiPaper-root": {
            overflowy: "hidden",
            color: '#ffffff'
        },
        "& .Mui-checked": {
            color: '#ffffff'
        },
        "& .MuiCheckBox-root": {
            color: '#ffffff'
        },
        "& .MuiSvgIcon-error": {
            color: '#c40018',
            fill: '#c40018',
        },

    },

}));
    const classes = pageStyles();

    const getTotal = () => {
        let total = 0
        list.map((item, index) => {
			const byteArray = new Uint8Array(item.Rate.data);
			const textDecoder = new TextDecoder();
			const res = textDecoder.decode(byteArray);
			const r = parseFloat(res).toFixed(2);
            total += calculateRate(r, item.FlagType) * item.Hours
        })
        return total.toFixed(2)
    };

	
	const BillList = async () => {
						    const batchSize = 50;
						    const numBatches = Math.ceil(list.length / batchSize); 
						    for (let i = 0; i < numBatches; i++) {
						        const startIndex = i * batchSize;
						        const endIndex = Math.min(startIndex + batchSize, list.length);
						        const batchEntries = list.slice(startIndex, endIndex); 
						        const batchTimeEntryIDs = batchEntries.map(item => item.time_entryID); 
						
						        logger(`Updating invoices for batch ${i + 1}:`, batchTimeEntryIDs);
						        try {
						            const response = await fetch("api/invoice/list", {
						                method: 'PATCH',
						                headers: { 'Content-Type': 'application/json' },
						                body: JSON.stringify({
						                    "InvoiceID": data.ID,
						                    "List": batchTimeEntryIDs
						                })
						            });
						
						            if (!response.ok) {
						                throw new Error(`Failed to update invoices for batch ${i + 1}`);
						            }
						        } catch (error) {
						            console.error(error);
						        }
						    }
						setRefresh(true);
						    setOpen(false);
						};


    const GetOverTime = async (sow) => {
        await fetch(`/api/SOW/OverTime/${sow}`, {
            method: 'Get',
        })
            .then(res => res.json())
            .then(json => setsOverTime(json))
    };

    React.useEffect(() => {

        if (refresh) {
            fetch(`api/Reports/POBilling/${data.ID}`, {
                method: 'Get',
            })
                .then(res => res.json())
                .then(json => {
                    logger("get invoices", json);
                    setList(json)
                    GetOverTime(json[0].SOWID)
                })

            if (data.IsBilled == 1) {
                fetch(`/api/DiscountID/${data.DiscountID}`, {
                    method: 'Get',
                })
                    .then(res => res.json())
                    .then(json => setDiscount(json));
            } else {
                logger(`/api/Discount_Active/${moment.utc(data.StartDate).format("yyyy-MM-DD")}/${moment.utc(data.EndDate).format("yyyy-MM-DD")}`)
                fetch(`/api/Discount_Active/${moment.utc(data.StartDate).format("yyyy-MM-DD")}/${moment.utc(data.EndDate).format("yyyy-MM-DD")}`, {
                    method: 'Get',
                })
                    .then(res => res.json())
                    .then(json => setDiscount(json));
            }

            setRefresh(false);
        }
    })

    const handleStatus = (status) => {
        if (status == 0) {
            return ("Pending");
        }
        if (status == 1) {
            return ("Approved");
        }
        if (status == -1) {
            return ("Rejected");
        }
    };

    const columns = [
        {
            name: "DayOf",
            label: "Day",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        moment.utc(list[dataIndex].DayOf).format("MM/DD/YYYY")
                    );
                }
            }
        },
        {
            name: "Name",
            label: "Name",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "position",
            label: "Position",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "Hours",
            label: "Hours",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
                    return (
                        <div style={list[dataIndex].overTimeWarning ? { color: "red" } : {}}>
                            {list[dataIndex].Hours}
                        </div>
                    );
                }
            }
        },
        {
            name: "FlagType",
            label: "Flag Type",
            options: {
                filter: false,
                sort: true,
            }
        },

        {
            name: "Rate",
            label: "Rate",
            options: {
                filter: false,
                sort: true,
                customBodyRenderLite: (dataIndex, rowIndex) => {
					if (list[dataIndex].Rate && list[dataIndex].FlagType)
					{
						const byteArray = new Uint8Array(list[dataIndex].Rate.data);
						const textDecoder = new TextDecoder();
						const res = textDecoder.decode(byteArray);
						const r = parseFloat(res).toFixed(2);      
			        return calculateRate(r, list[dataIndex].FlagType);
					    }
                    else{
						 logger("Data is missing for calculation");
                        return (
                            <Tooltip title='Failing' className={classes.root}>
                                <ReportGmailerrorredIcon color='error' />
                            </Tooltip>
                        );
                        }
                }
            }
        },
		{
		    name: "VerifyStatus",
		    options: {
		        filter: false,
		        sort: false,
		        empty: true,
		        customBodyRenderLite: (dataIndex, rowIndex) => {
		            const overTimeWarningStyle = list[dataIndex].overTimeWarning ? { color: "red" } : {};
		            return (
		                <Tooltip title={list[dataIndex].overTimeWarning ? "Overtime Warning" : ""}>
		                    <div style={overTimeWarningStyle}>
		                        {handleStatus(list[dataIndex].VerifyStatus)}
		                    </div>
		                </Tooltip>
		            );
		        }
		    }
		},
        {
            name: "PoNumber",
            label: "PoNumber",
            options: {
                filter: false,
                sort: true,
            }
        },
        {
            name: "InvoiceNumber",
            label: "Invoice Number",
            options: {
                filter: false,
                sort: true,
            }
        }, 
        {
            name: "projectName",
            label: "Project",
            options: {
                filter: false,
                sort: true,
            }
        },
		{
		    name: "taskName",
		    label: "Task",
		    options: {
		        filter: false,
		        sort: true,
		        customBodyRenderLite: (dataIndex, rowIndex) => {
		            const redStyle = list[dataIndex].RED === 1 ? { color: "red" } : {};
		            return (
		                <div>
		                    <Tooltip title={list[dataIndex].RED ? "Outside of user's role" : ""}>
		                        <div style={redStyle} className={classes.root}>
		                            {list[dataIndex].taskName}
		                        </div>
		                    </Tooltip>
		                </div>
		            );
		        }
		    }
}


    ];

    const getSavedRowsPerPage = () => {
        const savedValue = localStorage.getItem('rowsPerPage');
        return savedValue ? parseInt(savedValue) : 20; // Default value
    }
    // Save to local storage
    const saveRowsPerPage = (value) => {
        localStorage.setItem('rowsPerPage', value.toString());
    }

    const initialRowsPerPage = getSavedRowsPerPage();

    const options = {
        filter: true,
        filterType: 'dropdown',
        responsive: 'vertical',
        selectableRows: 'none',
        rowsPerPage: initialRowsPerPage,
        rowsPerPageOptions: [10, 20, 50, 100],
        selectableRows: 'none',textLabels: {
			toolbar: {
			  search: "Search",
			  downloadCsv: "Download Excel", 
			  print: "Print",
			  viewColumns: "View Columns",
			  filterTable: "Filter Table",
				},
		},
		 onDownload: (buildHead, buildBody, columns, data) => {
			// Custom buildHead and buildBody functions
			const customBuildHead = () => {
				var newColumns = columns.map(column => column.label);
				return newColumns;
			}
		
			const customBuildBody = () => {
				const headers = customBuildHead();
				for (var i = 0; i < data.length; i++) {
					var eachRow = data[i].data;
					logger("eachrow", eachRow)
					var formatDate= eachRow[0];
					
					 var payRate = eachRow[5];
						 const byteArray = new Uint8Array(payRate.data);
						 const textDecoder = new TextDecoder();
						 const res = textDecoder.decode(byteArray);
						 const rate = parseFloat(res).toFixed(2);

						 eachRow[5] = calculateRate(rate, eachRow[4]);  
					
					 eachRow[0] = moment.utc(formatDate.data).format("MM/DD/YYYY");
					 eachRow[6] = handleStatus(eachRow[6]);
				 }
				return customBodyForExcelReport({data:data, headers:headers});
			};
			
			const headers = customBuildHead();
			const rows = customBuildBody();
			//handleExport(rows, headers);
			//handleExport({rows:rows, headers:headers, filename:'InvoiceBreakdown.xlsx'} )
			var add_date = true;
			var columnIndexToRemove = null;
			var numberOfColumnsToRemove = null;
			var filename = 'InvoiceBreakdown.xlsx';
			
			if (columnIndexToRemove !== null) {
				if (numberOfColumnsToRemove !== null) {
					headers.splice(columnIndexToRemove, numberOfColumnsToRemove);
				} else {
					headers.splice(columnIndexToRemove, 1);
				}
			}
			const workbook = new ExcelJS.Workbook();
			const worksheet = workbook.addWorksheet('Sheet 1');
		
			const headerRow = worksheet.addRow(headers);
			headerRow.font = { bold: true };
		
			rows.forEach((row, rowIndex) => {
			    const newRow = worksheet.addRow(Object.values(row));
			
			    worksheet.columns.forEach((col, colIndex) => {
			        const headerLength = col.header ? col.header.length : 0; // Handle header if undefined
			        var maxColumnWidth = col.values.reduce((maxWidth, value) => {
			            if (value && value.length > maxWidth) {
			                return value.length;
			            }
			            return maxWidth;
			        }, 0);
			
			        if (maxColumnWidth > 40) {
			            maxColumnWidth = 40;
			        }
					col.width = Math.max(headerLength, maxColumnWidth) + 2;
					col.alignment = { vertical: 'top', horizontal: 'left', wrapText: true };
					if (list[rowIndex]) {
						if (colIndex === 9 && list[rowIndex].RED === 1) {
							newRow.getCell(colIndex + 1).font = { color: { argb: 'eb4034' } };
						}
						if ((colIndex === 3 ||  colIndex === 6) && list[rowIndex].overTimeWarning) {
							newRow.getCell(colIndex + 1).font = { color: { argb: 'eb4034' } };
						}
					}
				});
			});
		
			const currentDate = moment.utc().format("yyyy-MM-DD");
			// Generate the Excel file
			workbook.xlsx.writeBuffer().then(buffer => {
				const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
				const url = window.URL.createObjectURL(blob);
				const a = document.createElement('a');
				a.href = url;
				a.download = add_date ? (currentDate + "_" + filename || currentDate + '_' + 'datatable.xlsx')
					: (filename || 'datatable.xlsx');
				a.click();
			});
			return false;
		},
        customToolbar: () => (
            <div>
            {(data.IsBilled===0 || data.IsBilled=== false) &&
                <Button variant="contained" style={ data.IsBilled? { color: "#fff" } : {}} onClick={() => {
                    if (list.filter(item => { return item.VerifyStatus === 1 }).length === list.length) {
                        setAlertText('Permanently assign these entries to this Invoice')
                        setAlert(true)
                        setSucceed(true)
                    } else {
                        setAlertText('Permanently cannot assign these entries to this Invoice yet')
                        setAlert(true)
                        setSucceed(false)
                    }
                }}>
                    Bill List
                </Button>
                }
            </div>
            )
    };

    options.onChangeRowsPerPage = (newRowsPerPage) => {
        saveRowsPerPage(newRowsPerPage);
    };

    return (
        <div>
            <Tooltip title="Details" placement="top-end">
            <IconButton variant="contained" onClick={handleClickOpen}>
                <PieChartIcon color="primary" />
                </IconButton>
            </Tooltip>
            <Dialog open={open} onClose={handleClose} fullScreen>
                <DialogContent>
                    <Toolbar>
                        <IconButton
                            edge="start"
                            color="inherit"
                            onClick={handleClose}
                            aria-label="close"
                        >
                            <CloseIcon />
                        </IconButton>
                    </Toolbar>
                    <MuiThemeProvider theme={muiThemeDesign}>
                        <MUIDataTable className="invoiceTable"
                            title={
                                <Typography variant="h6" style={{ color: "white"}}>
                                    <div><div>{data.CommonName}-{data.PoNumber} <b> StartDate:</b> {moment.utc(data.StartDate).format("MM/DD/YYYY")}
                                        <b>  EndDate:</b> {moment.utc(data.EndDate).format("MM/DD/YYYY")} </div><div> RAW total:${getTotal()}  Discounted total:${applyDiscount(getTotal())} </div></div>
                                </Typography>
                            }
                            data={list}
                            columns={columns}
                            options={options}

                        />
                    </MuiThemeProvider>
                </DialogContent>
                <Dialog
                    open={ValueAlert}
                    onClose={handleAlertClose}
                    aria-labelledby="alert-dialog-title"
                    aria-describedby="alert-dialog-description"
                >
                    <DialogTitle id="alert-dialog-title">
                        {"Bill Invoice"}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText id="alert-dialog-description">
                            {alertText}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button disabled={succeed} component={Link} to="/Summary" onClick={() => { setAlert(false) }}>Go to Summary</Button>
                        <Button onClick={() => { setAlert(false) }}>Cancel</Button>
                        <Button disabled={!succeed} onClick={() => {
                            setAlert(false);
                            BillList();
                            onTrigger();
                        }} autoFocus>
                            ok
                        </Button>
                    </DialogActions>
                </Dialog>
            </Dialog>
        </div>
    );
}